export enum ChatType {
  PERSONAL_CHAT = 'individual',
  GROUP_CHAT = 'group',
}

export enum ChatMessageType {
  Text = 'text',
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  File = 'file',
  Location = 'location',
  Contact = 'contact',
  Sticker = 'sticker',
  Poll = 'poll',
}

export enum conversationsType {
  CHAT = 'chat',
  PERSONAL = 'personal',
  CLUB = 'club',
  GROUP = 'group',
}
